import { AspectRatioPicture } from "@faire/deprecated-retailer-visitor-shared/components/Image/AspectRatioPicture";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { optimizeImageUrlFillRectangle } from "@faire/web/common/images/optimizeImages";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import React from "react";

interface IProps {
  image: IImage;
  imageRatio: number;
  imageHeight: number;
}

export const SingleImage: React.FC<IProps> = ({
  image,
  imageRatio,
  imageHeight,
}) => {
  const isSSR = useIsSSR();
  return (
    <AspectRatioPicture $ratio={imageRatio} $height={imageHeight} $hideBorder>
      <img
        src={optimizeImageUrlFillRectangle(
          image,
          isSSR,
          imageRatio * imageHeight,
          imageHeight
        )}
      />
    </AspectRatioPicture>
  );
};
